import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { redirectToLogin } from "@/apollo/handlers/errorHandlers";
import Sidebar from "@/components/sidebar";
import MainLayout from "@/components/ui/mainLayout";
import Spinner from "@/components/ui/spinner";
import { useGetAuthQuery } from "@/graphql/common/common.hooks";
import { authService } from "@/services/authService";

function Shell() {
  const { data, loading, error } = useGetAuthQuery({
    fetchPolicy: "network-only",
    context: {
      errorType: "global",
    },
  });

  useEffect(() => {
    if (error) {
      redirectToLogin();
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      authService.setUser(data);
    }
  }, [data]);

  if (loading || !data?.user) {
    return <Spinner wrapperClassName="mt-5 pt-5" />;
  }

  return <MainLayout sidebar={<Sidebar />} content={<Outlet />} />;
}

export default Shell;
